export function validateFloatString(val: string): boolean {
    return (/^-?\d+(\.(\d*)?)?$/.test(val));
}

export function validateIntString(val: string): boolean {
    return (/^-?\d+$/.test(val));
}